<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col class="p-0">
		 <!--<b-row class="breadcrumbrow mt-1 m-0">				
			<b-col>
			 <h5 class="text-center">Admin Dashboard</h5>
			</b-col>				
		 </b-row>-->
		 <b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-4 col-sm-4 col-xs-4 text-left">
					<!-- <h3>Marketing Data</h3> -->
				</b-col>
				<b-col class="col-md-8 col-sm-8 col-xs-8 text-right">
							 
					 <download-csv type="button" class="btn btn-dark rounded-pill ml-2"  :data="recordsCsv" name="seller_approved_listed.csv" ><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Export CSV</download-csv>
				</b-col>
			</b-row>
		</b-container>
		
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
						<b-col cols="5">
							<span class="mr-2">Show</span>
							<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
							</b-form-select>
							<b-button size="sm ml-3 mr-2" @click="selectAllRows">Select all</b-button>
							<b-button size="sm mr-2" @click="clearSelected">Clear selected</b-button>
							
						 </b-col>
						 <b-col class="text-right">
							<b-button size="sm ml-3 mr-2" @click="sendBulkemail(1)">Update Profile Email</b-button>
							<b-button size="sm mr-2" @click="sendBulkemail(2)">Create Shop Email</b-button>
							 <b-button size="sm mr-2" @click="sendBulkemail(3)">Resend Password Email</b-button>
							 <b-button size="sm  mr-2" @click="sendEmail">Send Email</b-button>
						 </b-col>
						</b-row>
						<b-row class="mt-4 px-3">
							<b-col lg="2" class="text-left">
								<span class="mr-2">Date From</span>
								<b-form-datepicker id="datepicker-from" v-model="datefrom" class="mb-2" placeholder="No date"></b-form-datepicker>
							</b-col>
							<b-col lg="2" class="text-left">
								<span class="mr-2">Date To</span>
								<b-form-datepicker id="datepicker-to" v-model="dateto" class="mb-2" placeholder="No date"></b-form-datepicker>
							</b-col>
							<!--<b-col lg="2" class="text-left">
								<span class="mr-2">Role</span>
								<b-form-select v-model="reg_role" required>
									<b-form-select-option value="">All</b-form-select-option>
									<b-form-select-option value="seller">Seller</b-form-select-option>
									<b-form-select-option value="sales-advisor">Sales Advisor</b-form-select-option>
								</b-form-select>
							</b-col> -->
							<b-col lg="2" class="text-left">
								<span class="mr-2">Status</span>
								<b-form-select v-model="reg_status" required>
									<b-form-select-option value="-1">All</b-form-select-option>
									<b-form-select-option value="0">New</b-form-select-option>
									<b-form-select-option value="1">Processing</b-form-select-option>
									<b-form-select-option value="2">Complete</b-form-select-option>
									<b-form-select-option value="3">Not Interested</b-form-select-option>
									<!-- <b-form-select-option value="4">Deactivate</b-form-select-option> -->
								</b-form-select>
							</b-col>
							<b-col lg="2" class="text-left">
								<b-button pill variant="primary" class="mt-4" @click="loadData()" size="sm">Submit</b-button>
							</b-col>
							<b-col lg="1" class="text-left">
								
							</b-col>
							<b-col lg="3">
								<span class="mr-2">Filter</span>
								<b-input-group >
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"  ref="selectableTable" selectable @row-selected="onRowSelected"> 
								
								<template v-slot:cell(selected)="{ rowSelected }">
										<template v-if="rowSelected">
									  <span aria-hidden="true">&check;</span>
									  <span class="sr-only">Selected</span>
									</template>
									<template v-else>
									  <span aria-hidden="true">&nbsp;</span>
									  <span class="sr-only">Not selected</span>
									</template>
								</template>
								<template v-slot:cell(lastLoginTime)="row">
									Count: <small>{{row.item.totalLoginTime || '---'}}</small>
									<br/>
									Time: <small>{{row.value!=''?$moment(row.value).format('DD-MM-YYYY HH:mm:ss'): '---' }}</small>
									
									
								
								</template>
								
									 <template v-slot:cell(insert_time)="row">
										<span>{{$moment(row.value).format('DD-MM-YYYY HH:mm:ss')}}</span>
									</template> 
									<template v-slot:cell(reg_status)="row"> 
										<span v-if="row.item.total_products>0"><b-badge pill variant="primary" >Listed: {{row.item.total_products}}</b-badge></span>
										<span v-else>
										<b-badge pill variant="primary" v-if="row.value == 0">NEW</b-badge>
										<b-badge pill variant="warning" v-if="row.value == 1" style="color:#fff;background-color:#f79800;">Processing</b-badge>
										<b-badge pill variant="success" v-if="row.value == 2">Complete</b-badge>
										<b-badge pill variant="danger" v-if="row.value == 3">Not Interested</b-badge>
										<b-badge pill variant="danger" v-if="row.value == 4">Deactivate</b-badge>
										</span>
										
									</template>
									<template v-slot:cell(account_created)="row">
										<b-badge pill variant="primary" v-if="row.value == 0">NO</b-badge>
										<b-badge pill variant="success" v-if="row.value == 2">YES</b-badge>
									</template>
									<template v-slot:cell(actions)="row">
										<div style="width:100px">
										<!--v-if="row.item.account_created != 2" -->
											<b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="deactivateRole(row.item)" size="sm"><b-icon icon="person-dash"></b-icon></b-button>
											
											<!--<b-link @click="$root.sharepopupSA(),setiamiconfor('whatsapp')"><b-img  src="@/assets/whatsapp.svg" class="socialIcondiv--icon" width="25px;"></b-img></b-link>  -->
										<whatappchat-user :phone="row.item.mobile" :whatsapp="row.item.whatsapp" :userId="row.item.id" listtype="mark"></whatappchat-user>

											
											<!-- <b-button pill variant="primary" class="mr-1 icon-btn" @click="showCommentModal(row.item, row.index, $event.target)" size="sm"><b-icon icon="pencil"></b-icon></b-button>
											<b-button v-if="row.item.account_created != 2" pill variant="primary" class="mr-1 icon-btn" @click="deactivateRole(row.item)" size="sm"><b-icon icon="person-check"></b-icon></b-button> -->
										</div>
									</template> 
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="comment-model" title="View Comment" size="lg" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-container fluid>
						<b-row class="mb-1">
							<b-col cols="12">
								<b-row class="mb-3">
									<b-col>
										<div class="comment-box" style v-if="selectedItem.comment == null">No Comment</div>
										<div class="comment-box" v-else>
											<p v-for="(item,index) in selectedItem.comment" :key="index">{{item}}</p>
										</div>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="5">
										<b-form-select size="sm" v-model="selectedItem.reg_status">
                                            <b-form-select-option value="0">New</b-form-select-option>
											<b-form-select-option value="1">Processing</b-form-select-option>
											<b-form-select-option value="2">Complete</b-form-select-option>
											<b-form-select-option value="3">Not Interested</b-form-select-option>
											<b-form-select-option value="4">Deactivate</b-form-select-option>
                                        </b-form-select>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col><b-form-textarea v-model="selectedItem.new_comment" size="sm" rows="3" required placeholder="Add comment..."></b-form-textarea></b-col>
								</b-row>
							</b-col>
						</b-row>
					</b-container>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
	</b-col>
	</b-row>		
	</b-container>
	<shareemail-popup :userData="selected"></shareemail-popup>
	</div>
	
</template>
<script>
//import Header from "@/components/admin/Header.vue";
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
import ShareemailPopup from "@/components/shareemail-popup.vue";
import Whatappchatuser from "@/components/whatapp-chat-user.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"shareemail-popup": ShareemailPopup,
		"whatappchat-user": Whatappchatuser,
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
			loading: true, 
			
			datefrom: '',
			dateto: '',
			reg_status: -1,
			reg_role: '',
                        product_csv: null,

            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_inf: {},
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'secureapi/registration-reload_active',
			updateUrl: this.$root.WEBAPI+'secureapi/registration-update',
			convertUrl: this.$root.WEBAPI+'secureapi/registration-convert',
			deactivateUrl: this.$root.WEBAPI+'secureapi/deactivate-accout',
			importUrl: this.$root.NEWAPIURL+'secureapi/marketing-import',
			sendEmailbulkUrl: this.$root.WEBAPI+'secureapi/sendEmailbulktoseller',
			recordsCsv: [],
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Products',
					active: true
				}
			],
			fields: [
				{ key: 'Selected',label: 'Selected'},
                { key: 'id', label: 'ID'},
                { key: 'fullname', label: 'Full name',
					formatter: (value, key, item) => { 
						return item.prefix+' '+item.fullname;
					}
				},
                { key: 'email', label: 'Email'},
				{ key: 'mobile', label: 'Mobile'},
				{ key: 'role', label: 'Role' },
				{ key: 'location', label: 'Location' },
				{ key: 'workarea', label: 'Work Area' },
				/*{ key: 'ipaddress', label: 'Ip Address'},
				{ key: 'platform', label: 'Platform',
					formatter: (value, key, item) => { 
						if(item.platform == null || item.platform == ''){
							return '';
						}
                        var platform = JSON.parse(item.platform);
                        //console.log(platform.platform+', '+platform.browser);
						return platform.platform+', '+platform.browser;
					},
				},*/
				{ key: 'reg_status', label: 'Status'},
				{ key: 'account_created', label: 'Account'},
                { key: 'insert_time', label: 'Time'},
                { key: 'lastLoginTime', label: 'Login'},
				{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [25,50,100,200,300,500],
			perPage: 25,
			sortBy: 'whatsapp',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {product_data:{}, tier_price:[]},
			emptyItem: {
				id: 0,
				product_id: '',
				title: '',
				short_description: '',
				description: '',
				sku: '',
				category: '',
				price: '',
				special_price: '',
				product_data:{},
				tier_price: [],
                status: 0
			},
			counterindex:1,
			selected:[],
		};
	},
	methods: {
		removeTierPrice(i){
			this.selectedItem.tier_price.splice(i,1);
		},
		addTierPrice(){
			console.log(JSON.stringify(this.selectedItem.tier_price));
			var d = new Date();
			this.selectedItem.tier_price.push({'id':d.getTime(), 'min_qty':0, 'price':0});
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showCommentModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			if(item.comment){
				this.selectedItem.comment = JSON.parse(item.comment);
			}
			this.$root.$emit('bv::show::modal', 'comment-model', button)
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();

			var comment = '';
			if(this.selectedItem.comment !=  null){
				comment = this.selectedItem.comment.slice(0);
			}else{
				comment = [];
			}
			comment.push(this.selectedItem.new_comment);

            self.axios.post(self.updateUrl, {
				accesskey: self.$session.get('access_key'),
				comment: JSON.stringify(comment),
				reg_role: this.selectedItem.reg_role,
				reg_status: this.selectedItem.reg_status,
				id: this.selectedItem.id
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('comment-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		deactivateRole(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to Deactivate user account.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deactivateUrl, {
						accesskey: self.$session.get('access_key'),
						email: item.email,
						status:'deactive',
						
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Deactivate',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
						}
                                                self.initload();
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					var recordsNew = response.data.result.records;
					self.loading = false;
					//self.totalRows = self.records.length;
					var recordsData =[];
					recordsNew.forEach(item => {
					if(item.total_products>0){
					/* var arrayCsv={'Seller Name':item.fullname,'Phone':item.mobile}; */
					var arrayCsv={'Prefix':item.prefix,'Seller Name':item.fullname,'Email':item.email,'Phone':item.mobile,'Location':item.location};					
					self.recordsCsv.push(arrayCsv);
						recordsData.push(item);
					}
					});
					
					self.records = recordsData;
					self.totalRows = recordsData.length;
					
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		loadData(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key'),
				datefrom: self.datefrom,
				dateto: self.dateto,
				role: self.reg_role,
				status: self.reg_status
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					var recordsNew = response.data.result.records;
					self.loading = false;
					//self.totalRows = self.records.length;
					
					
					
					var recordsData =[];
					recordsNew.forEach(item => {
					if(item.total_products>0){
					/* var arrayCsv={'Seller Name':item.fullname,'Phone':item.mobile}; */
					var arrayCsv={'Prefix':item.prefix,'Seller Name':item.fullname,'Email':item.email,'Phone':item.mobile,'Location':item.location};					
					self.recordsCsv.push(arrayCsv);
						recordsData.push(item);
					}
					});
					
					self.records = recordsData;
					self.totalRows = recordsData.length;
					
					
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		triggerImportCSV(){
                    console.log('trigger import csv');
                    document.getElementsByClassName('importfile')[0].querySelector('input').click();
                },
		importCSV(event){
			var self = this;
			self.loading = true;
            
                        let formData = new FormData();
                        formData.append('csvfile', document.getElementsByClassName('importfile')[0].querySelector('input').files[0]);
                        formData.append('accesskey', this.$session.get('access_key'));

                        self.axios.post(self.importUrl, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0') {
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
                            event.target.value = '';
			})
			.catch(function (error) {
				alert(error);
			});
		},
		/*Email SEND */
		onRowSelected(items) {
			this.selected = items
		  },
		selectAllRows() {
			this.$refs.selectableTable.selectAllRows()
		  },
		  clearSelected() {
			this.$refs.selectableTable.clearSelected()
		  },
		sendBulkemail(emailtemp){
				var self = this;
				this.$bvModal.msgBoxConfirm('Please confirm that you want to Send Email!.', {
					title: 'Please Confirm',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'YES',
					cancelTitle: 'NO',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if(value == true){
						self.axios.post(self.sendEmailbulkUrl, {
							accesskey: self.$session.get('access_key'),
							user_data: self.selected,
							emailtemp: emailtemp,
							status: 1
						})
						.then(function (response) {
							if(response.data.error == 0 || response.data.error == '0'){
								self.$bvToast.toast(response.data.message, {
									title: 'Email Status',
									toaster: 'b-toaster-bottom-right',
									autoHideDelay: 5000,
									variant: 'success',
									solid: true,
									appendToast: true
								});
								//self.initload();
							}else{
							
								self.$bvToast.toast(response.data.message, {
									title: 'Email Status',
									toaster: 'b-toaster-bottom-right',
									autoHideDelay: 5000,
									variant: 'warning',
									solid: true,
									appendToast: true
								});
							
							}
							
						})
						.catch(function (error) {
							alert(error);
						});
					}else{
						//alert('no '+item.id);
					}
				})
				.catch(err => {
					// An error occurred
					console.log(err);
				})
			},
			setiamiconfor(socialame){
			this.$root.share.iamiconfor=socialame;
		},
		sendEmail(){
			var self = this;
			//console.log('UserSelect:'+self.selected.length);
			if(self.selected.length>0){
				
				self.$root.$emit('bv::show::modal', 'showShareEmailModal');
			}else{
				var mess ='Please select at least one Email!';
				self.$bvToast.toast(mess, {
				title: 'Email',
				toaster: 'b-toaster-bottom-right',
				autoHideDelay: 5000,
				variant: 'danger',
				solid: true,
				appendToast: true
				});
			}
		}

	}
}
</script>
<style>
</style>